import { Group, Pagination, Text } from "@mantine/core";

type Props = {
  readonly page: number;
  readonly pageSize: number;
  readonly total: number;
  readonly totalPages: number;
  readonly onPageChange: (page: number) => void;
};

/** 表格底部分页：展示总数、当前页/总页数，并提供页码切换。 */
export function TablePagination(props: Props) {
  const { page, pageSize, total, totalPages, onPageChange } = props;

  if (total === 0) {
    return (
      <Text size="sm" c="dimmed" ta="center" py="sm">
        共 0 条记录
      </Text>
    );
  }

  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);

  return (
    <Group justify="space-between" align="center" mt="sm" wrap="wrap" gap="sm">
      <Text size="sm" c="dimmed">
        共 {total.toLocaleString()} 条，第 {page} / {totalPages} 页（本页 {from}-{to}）
      </Text>
      {totalPages > 1 ? (
        <Pagination value={page} onChange={onPageChange} total={totalPages} size="sm" />
      ) : null}
    </Group>
  );
}
